export const environment = {
  production: true,
  //Prod
  urlApiManagement: 'https://prd-ms-management.azurewebsites.net',
  urlProfileManagement: 'https://prd-ms-profile-management.azurewebsites.net',
  urlStp: 'https://prd-ms-stp.azurewebsites.net',
  urlTaskManagement: 'https://prd-ms-task-management.azurewebsites.net',
  urlQueueManager: 'https://prd-ms-queue-manager.azurewebsites.net',
  urlVendorManagement: 'https://prd-ms-vendor-management.azurewebsites.net',
  urlSuperClients: 'https://prd-ms-super-clients.azurewebsites.net',
  urlProjectManagement: 'https://prd-ms-project-management.azurewebsites.net',
  redirectUri: 'https://prd-am-operationmgt.nttltd.global.ntt/home',
  clarityKey: 'o5seldwlzv'
};
